import { api } from '../lib/api'
import type {
  CreateFeedbackTicketPayload,
  FeedbackTicket,
  FeedbackTicketCategory,
  FeedbackTicketStatus,
  FeedbackTicketType,
} from '../types/feedback'

type FeedbackListResponse = FeedbackTicket[] | { results?: FeedbackTicket[] }

export async function createTicket(payload: CreateFeedbackTicketPayload) {
  const { data } = await api.post<FeedbackTicket>('/api/feedback/tickets/', payload)
  return data
}

export async function listTickets(params?: {
  mine?: boolean
  type?: FeedbackTicketType
  status?: FeedbackTicketStatus
  category?: FeedbackTicketCategory
}) {
  const query: Record<string, string> = {}
  if (typeof params?.mine === 'boolean') query.mine = params.mine ? '1' : '0'
  if (params?.type) query.type = params.type
  if (params?.status) query.status = params.status
  if (params?.category) query.category = params.category

  const { data } = await api.get<FeedbackListResponse>('/api/feedback/tickets/', { params: query })
  if (Array.isArray(data)) return data
  return Array.isArray(data?.results) ? data.results : []
}
